module.exports = __webpack_public_path__ + "img/cat1.3f3939b3.png";